
import linkify from 'linkify-html';
import { escape } from 'html-escaper';
import clipText from '../helpers/ClipText.js';
export default {
  props: {
    text: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: 'p'
    },

    acceptHtml: {
      type: Boolean
    },

    links: {
      type: Boolean,
      default: true
    },

    lines: {
      type: [Number, String],
      default: undefined
    },

    highlight: {
      type: String,
      default: ''
    }
  },
  watch: {
    '$slots.default' () {
      this.clamp();
    },

    lines () {
      this.clamp();
    }
  },

  updated () {
    if (!this.$el || this.$el.nodeType === Node.COMMENT_NODE) { return; }

    this.clamp();
  },

  mounted () {
    if (!this.$el || this.$el.nodeType === Node.COMMENT_NODE) { return; }

    this.clamp();
    const observer = new ResizeObserver(() => this.clamp());
    observer.observe(this.$el);
  },

  methods: {
    parsedText () {
      let text = this.text;

      if (text === null && !!this.$slots.default) {
        text = this.$slots.default?.filter(x => 'text' in x)?.map(x => x.text)?.join('')?.trim() ?? '';
      }

      if (text === null) {
        text = '';
      }

      if (!this.acceptHtml) {
        text = escape(text);
      } else {
        text = text
        // remove inline events
          .replace(/\s(on[A-z]+=["'].*["'])(?= )|(on[A-z]+=\S+)(?=>| [A-z])/g, '')
        // remove javascript hrefs
          .replace(/(href=['"]javascript:[^\s>]*)/g, '')
        // escape script, style and link tags
          .replace(/(?:<(\/{0,1}(?:script|style|link).*)>)/g, '&lt;$1&gt;')
        ;
      }

      if (this.highlight) {
        text = text.replace(new RegExp(`(${this.highlight})+`, 'gi'), match => `<mark>${match}</mark>`);
      }

      if (this.links) {
        try {
          text = linkify(text, {
            target: '_blank',
            rel: 'noopener noreferrer',
            truncate: 25,
            attributes: {
              tabindex: ((this.$attrs && this.$attrs.tabindex) || 0).toString()
            }
          });
        } catch {}
      }

      return text;
    },

    clamp () {
      if (this.lines) {
        clipText(this.$el, {
          clamp: Number(this.lines)
        });
      }
    }
  }
};
